import { derinApiClient } from "./setup";
import { DerinApiResponse, PaginatedFeedbackSessionResponse, FeedbackSessionDetailResponse, PaginatedGroupedFeedbackResponse } from "./interface";

export interface GetFeedbackSessionsParams {
  status?: "New" | "Reviewed";
  userName?: string;
  surveyOriginalId?: string;
  page?: number;
  limit?: number;
}

export const getFeedbackSessions = async (
  params?: GetFeedbackSessionsParams
): Promise<PaginatedFeedbackSessionResponse> => {
  const queryParams = new URLSearchParams();
  if (params?.status) {
    queryParams.append("status", params.status);
  }
  if (params?.userName) {
    queryParams.append("userName", params.userName);
  }
  if (params?.surveyOriginalId) {
    queryParams.append("surveyOriginalId", params.surveyOriginalId);
  }
  queryParams.append("page", String(params?.page ?? 1));
  queryParams.append("limit", String(params?.limit ?? 20));

  const url = `/feedback-session?${queryParams.toString()}`;

  const response = await derinApiClient().get<
    DerinApiResponse<PaginatedFeedbackSessionResponse>
  >(url);
  return response.data.data;
};

export interface GetGroupedFeedbackParams {
  status?: "New" | "Reviewed";
  userName?: string;
  page?: number;
  limit?: number;
}

export const getGroupedFeedbackSessions = async (
  params?: GetGroupedFeedbackParams
): Promise<PaginatedGroupedFeedbackResponse> => {
  const queryParams = new URLSearchParams();
  if (params?.status) {
    queryParams.append("status", params.status);
  }
  if (params?.userName) {
    queryParams.append("userName", params.userName);
  }
  queryParams.append("page", String(params?.page ?? 1));
  queryParams.append("limit", String(params?.limit ?? 20));

  const url = `/feedback-session/grouped?${queryParams.toString()}`;

  const response = await derinApiClient().get<
    DerinApiResponse<PaginatedGroupedFeedbackResponse>
  >(url);
  return response.data.data;
};

export const getFeedbacksBySessionId = async (
  sessionId: string
): Promise<FeedbackSessionDetailResponse> => {
  const response = await derinApiClient().get<
    DerinApiResponse<FeedbackSessionDetailResponse>
  >(`/feedback-session/${sessionId}/feedback`);
  return response.data.data;
};
